module.exports = __webpack_public_path__ + "img/product_72.25b771b.webp";